export default __webpack_public_path__ + "static/media/contact.6556c938.png";